module.exports = require("@swa-ui/personal-info/src/ContactInformation/ContactInformation.module.scss");